
import "../styles/main.scss";

//import utils from './parts/utils';

//import modal from './parts/modal';
import menu from './parts/menu';
//import scrollEvents from './parts/scrollEvents';
import sliders from './parts/sliders';
//import button from './parts/button';
//import wordsAni from './parts/wordsAni';
//import listAni from './parts/listAni';
//import configurator from './parts/configurator';
//import lightgallery from './parts/lightgallery';
//import dropdowns from './parts/dropdowns';
//import loadMorePosts from './parts/loadMorePosts';
//import filters from './parts/filters';
import inAni from './parts/inAni';

//modal.init();
menu.init();
sliders.init();
//button.init();
//wordsAni.init();
//listAni.init();
//configurator.init();
//scrollEvents.init();
//lightgallery.init();
//dropdowns.init();
//loadMorePosts.init();
//filters.init();
inAni.init();

// Form Submit
/*
document.addEventListener( 'wpcf7submit', function( event ) {
    if(event?.detail?.apiResponse?.status == 'mail_sent'){

        utils.getData(window.ajaxUrl, {
            id: window.postID,
            action: 'formMessage'
        }).then((data) => {

            document.querySelectorAll('.wpcf7-form div').forEach((item) => {
                if(!item.classList.contains('wpcf7-response-output')){
                    item.remove();
                }
            });

            document.querySelector('.wpcf7-form').innerHTML += data;
            button.init();
        });
    }
}, false );
*/


const modalButtons = document.querySelectorAll('[data-modal-toggle]');

if(modalButtons.length > 0){
    modalButtons.forEach((item) => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            const modalId = item.dataset.modalToggle;
            const defunto = item.dataset.defunto;
            const modal = document.getElementById(modalId);
            const modalInput = modal.querySelector('input[name="defunto"]');

            if(modal){
                modal.classList.toggle('opacity-0');
                modal.classList.toggle('pointer-events-none');
                modal.classList.toggle('translate-y-4');

                if (defunto){

                    if (modalInput){
                        modalInput.value = defunto; 
                    }else{
                        const input = document.createElement('input');
                        input.setAttribute('type', 'hidden');
                        input.setAttribute('name', 'defunto');
                        input.setAttribute('value', defunto);
                        modal.querySelector('form').appendChild(input);
                    }
                }
            }
        });
    });
}